import axiosClient from "./axiosClient";

const serviceUrl = '/store/prescription';
const MedicinePharmacyService = {
    getListAllPharmacy: async (page) => {
      const params = {page: page, limit: 10 };
      const url = serviceURL + `/listPrescription`;
      const response = await axiosClient.get(url, {
        params: params
      })
      return response;
    },

    getDetailPharmacy: async (id = 0) => {
      const params = {id: id };
      const url = serviceUrl + `/getDetailPrescription`
      const response = await axiosClient.get(url, {
        params: params
      })
      return response;
    },

    updatePharmacy: async (id, body) => {
      const url = serviceURL + `/updatePrescription?id=${id}`;
      const response = await axiosClient.put(url, body)
      return response;
    },

    deletePharmacyDetail: async (id) => {
      const params = { id: id };
      const url =  `/store/prescriptiondetail/deletePrescriptionDetail`;
      const response = await axiosClient.delete(url, {
        params: params
      })
      return response;
    },
};

export default MedicinePharmacyService;
